import { addDays, comparePlainDate, plainDateFromIso, plainDateToIso, } from '../custody/time-zone.js';
import { schoolHolidayDays } from './school-holidays.js';
/**
 * D'où un dossier tient ses congés scolaires.
 *
 * **Pourquoi plusieurs sources.** Le calendrier officiel français couvre la métropole et
 * elle seule : la Corse et l'outre-mer suivent leurs propres dates, une école à l'étranger
 * n'entre dans aucune zone A/B/C, et un établissement privé hors contrat fixe les siennes.
 * Pour toutes ces familles, la déduction par code postal ne rend rien — et le calendrier
 * reste muet. Le fichier déposé est leur porte d'entrée.
 *
 * **La liste est ouverte.** Elle est faite pour s'allonger : un calendrier belge ou suisse,
 * l'abonnement à une URL, une académie choisie à la main. Tout ce qui suit ne connaît que
 * `kind`, jamais la liste — ajouter une source ne demande pas de retoucher l'affichage.
 */
export const HOLIDAY_SOURCE_KINDS = ['education_gouv', 'ics'];
export function isHolidaySourceKind(valeur) {
    return typeof valeur === 'string' && HOLIDAY_SOURCE_KINDS.includes(valeur);
}
/**
 * Les jours de congés d'un intervalle, en clés ISO — **sans jamais lever**, quelle que soit
 * la source.
 *
 * Même contrat que `schoolHolidayDays`, et pour la même raison : c'est un affichage. Le
 * calendrier laisse feuilleter les mois librement, et une exception à chaque clic sur
 * « mois suivant » remplacerait un calendrier utile par un écran d'erreur. Ce qu'on ne
 * sait pas ne se peint pas.
 */
export function holidayDays(source, from, to) {
    if (!source)
        return new Set();
    if (source.kind === 'education_gouv') {
        return source.zone ? schoolHolidayDays(source.zone, from, to) : new Set();
    }
    const jours = new Set();
    for (const periode of source.periods) {
        let debut;
        let fin;
        try {
            debut = plainDateFromIso(periode.from);
            fin = plainDateFromIso(periode.to);
        }
        catch {
            // Une période illisible est une période qu'on n'affiche pas. Elle ne doit pas
            // emporter les autres avec elle.
            continue;
        }
        let jour = comparePlainDate(debut, from) >= 0 ? debut : from;
        // `to` est le jour de reprise : il est exclu des vacances, ici comme ailleurs.
        while (comparePlainDate(jour, fin) < 0 && comparePlainDate(jour, to) <= 0) {
            jours.add(plainDateToIso(jour));
            jour = addDays(jour, 1);
        }
    }
    return jours;
}
//# sourceMappingURL=holiday-source.js.map